<div class="row p-2">
    <div><mat-form-field appearance="fill" class="w-100">
            <textarea matInput placeholder="Input" pe="text" [formControl]="comment_regtext"></textarea>
        </mat-form-field></div>
</div>
<div class="row p-2">
    <button class="btn btn-primary w-100" (click)="submitCommentsAndReturn()">Submit</button>
</div>